<mat-toolbar color="secondary">
  @if (isProtected) {
    <div
      matTooltip="{{ showToolTip()? ('DIALOGS.PROTECTEDBYWEBDOKU' | translate):'' }}">
      <mat-icon class="lock-icon">lock_outlined</mat-icon>
    </div>
  }
  <ldw-document-title [document]="document"></ldw-document-title>
  <span class="spacer"></span>
  <ldw-document-images [document]="document"></ldw-document-images>

  @if (hasStatusLabel) {
    <ldw-status-label [status]="currentStatus"></ldw-status-label>
  }
  @if (hasStatusChange) {
    <ldw-status-select
      class="document-edit"
      [initialValue]="currentStatus.id"
      (statusChanged)="statusHasChanged($event)"
      [emptyDisplayValue]="'STATUS.NONE' | translate"
    ></ldw-status-select>
  }

  <div class="buttons">
    <button mat-icon-button [matMenuTriggerFor]="infoMenu" matTooltip="{{ showToolTip()? ('DOCUMENT.MOREOPTIONS' | translate):'' }}">

      <mat-icon>more_vert</mat-icon>
    </button>
    @if (isEditButtonAllowed) {
      <button
        mat-icon-button
        (click)="editDocument()"
        matTooltip="{{ showToolTip()? ('DIALOGS.EDIT' | translate):'' }}">
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if (isBookmarkButtonAllowed) {
      <button
        mat-icon-button
        (click)="addToBookmark()"
        matTooltip="{{ showToolTip()? ('DIALOGS.ADDTOBOOKMARK' | translate):'' }}"
        >
        <mat-icon>bookmark</mat-icon>
      </button>
    }
    <button mat-icon-button (click)="close()" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
<mat-menu #infoMenu="matMenu" yPosition="below">
  @if (isDeleteAllowed) {
    <div>
      <button mat-menu-item (click)="deleteDocument()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'DIALOGS.DELETE' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
    </div>
  }
  @if (isCopyAllowed) {
    <div>
      <button mat-menu-item (click)="copyDocument()">
        <mat-icon>output</mat-icon>
        <span>{{ 'DIALOGS.COPY' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
    </div>
  }
  <button mat-menu-item (click)="showChanges()">
    <mat-icon>change_circle</mat-icon>
    <span>{{ 'DOCUMENT.CHANGES' | translate }}</span>
  </button>
  <button mat-menu-item (click)="showInfo()">
    <mat-icon>info</mat-icon>
    <span>{{ 'DOCUMENT.INFO' | translate }}</span>
  </button>
  @if (isHistoryButtonAllowed) {
    <button mat-menu-item (click)="showHistory()">
      <mat-icon>history</mat-icon>
      <span>{{ 'DOCUMENT.HISTORY' | translate }}</span>
    </button>
  }
</mat-menu>
